import { render } from "./TripPaymentDetails.vue?vue&type=template&id=c15ae7d8&scoped=true&lang=pug"
import script from "./TripPaymentDetails.vue?vue&type=script&lang=ts"
export * from "./TripPaymentDetails.vue?vue&type=script&lang=ts"

import "./TripPaymentDetails.vue?vue&type=style&index=0&id=c15ae7d8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c15ae7d8"

export default script